import { Api } from '@coder-house/ch-coder-util'

const { VUE_APP_CH_WEAVER } = process.env

interface FlagEvaluationResponse {
  match: boolean
  rules: any[]
}

export const evaluateFlag = async (
  flagId: string,
  key: string,
  payload: Record<string, string | number | boolean | unknown[]>,
  namespace: string = 'platform',
) => {
  const result = await Api.post<FlagEvaluationResponse>(`${VUE_APP_CH_WEAVER}/flags/v1/${flagId}/evaluate/${key}`, payload, null, {
    headers: {
      'X-Namespace': namespace
    }
  })

  return result.match
}
